import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import SearchResults from "./SearchResults";

export default function OperatorBookingPage() {
  const { operatorSlug } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (!operatorSlug) return;

    const currentOperatorKey = searchParams.get("operatorKey");

    if (currentOperatorKey === operatorSlug) return;

    const nextParams = new URLSearchParams(searchParams);
    nextParams.set("operatorKey", operatorSlug);

    setSearchParams(nextParams, { replace: true });
  }, [operatorSlug, searchParams, setSearchParams]);

  return <SearchResults />;
}
